import React from "react";

const SettingToggle = ({ active, onChange, disabled }) => (
  <button
    onClick={(e) => {
      e.stopPropagation();
      if (!disabled) onChange?.(!active);
    }}
    disabled={disabled}
    className={`w-10 h-5 rounded-full p-[3px] transition-colors relative flex items-center ${
      disabled
        ? "bg-[#E4E4E4] cursor-not-allowed"
        : `cursor-pointer ${active ? "bg-[#636369]" : "bg-[#C5C5C7]"}`
    }`}
  >
    <div
      className={`w-[14px] h-[14px] bg-white rounded-full transition-transform shadow-sm ${
        active ? "translate-x-[20px]" : "translate-x-0"
      }`}
    />
  </button>
);

export default React.memo(SettingToggle);
